import React, { useEffect, useState } from 'react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { useMessage } from '../../../hooks'
import { Row, Col } from '@paypalcorp/pp-react'
import { Dropdown, DropdownItem } from '@paypalcorp/ppods-react'

import _filter from 'lodash.filter'

import { getAppSelection, setAppSelection } from '../../../utils/session-utils'

function AppSwitcher() {
  const localizedMsg = useMessage()

  const {
    enviroment,
    homePageDataLoading,
    currentApps,
    setCurrentAppValue,
    setReloadPage,
    setCurrentLiveApp,
    setCurrentSandboxApp,
  } = useApplicationContext()
  const [appList, setAppList] = useState([])
  const [selectedApp, setSelectedApp] = useState()

  /* Param 'list' will always have 1+ items */
  const manageAppSelection = (list) => {
    let appInSession = getAppSelection()
    let appCheck = _filter(list, ['value', appInSession])

    /* If app stored in session is no longer in the app-list, pick the first app */
    let appToSelect = appCheck.length === 0 ? list[0].value : appCheck[0].value
    setSelectedApp(appToSelect)
    setAppSelection(appToSelect)

    /* If selection stored in session was 'All Apps' */
    if (appToSelect === 'apps') {
      setCurrentAppValue(list[1].value)
    } else {
      setCurrentAppValue(appToSelect)
    }
    if (enviroment === 'live') {
      setCurrentLiveApp(appToSelect)
    } else {
      setCurrentSandboxApp(appToSelect)
    }
  }

  useEffect(() => {
    if (homePageDataLoading === undefined || homePageDataLoading === true) {
      return
    }
    let list
    if (!currentApps || (currentApps && currentApps.length === 0)) {
      list = []
    } else {
      try {
        list = JSON.parse(JSON.stringify(currentApps))
      } catch (err) {
        list = []
      }
    }
    if (enviroment === 'live' && list.length > 0) {
      list.unshift({
        name: localizedMsg('dashboard.app.switcher.set.allapps'),
        clientid: 'apps',
        primaryText: localizedMsg('dashboard.app.switcher.set.allapps'),
        value: 'apps',
      })
    }
    setAppList(list)

    /* 
      Auto selecting a value in the app-switcher makes sense only if there is an actual app present
    */
    if (list.length > 0) {
      manageAppSelection(list)
    }
  }, [homePageDataLoading])

  const onClickAppSwitcherEvent = (value) => {
    setSelectedApp(value)
    setAppSelection(value)
    if (value === 'apps') {
      setCurrentAppValue(appList?.[1].value)
    } else {
      // Find the selected app in the list
      const selectedAppData = appList.find((app) => app.value === value)
      setCurrentAppValue(selectedAppData?.value)
    }
    if (enviroment === 'live') {
      setCurrentLiveApp(value)
    } else {
      setCurrentSandboxApp(value)
    }
    setReloadPage('yes')
  }

  const appsContent = (
    <>
      <Row>
        <Col>
          <Dropdown
            id="selected-app"
            titleText=""
            label={
              appList.find((app) => app.value === selectedApp)?.primaryText ||
              localizedMsg('dashboard.app.switcher.dropdown.set')
            }
            value={selectedApp}
            selected={(event) => {
              const value = event.detail.item.value
              onClickAppSwitcherEvent(value)
            }}
            style={{
              display: 'flex',
              width: '210px',
              border: '1px solid #ccc',
              borderRadius: '6px',
            }}
            data-dxa="App Switcher, apps-value-dropdown click"
          >
            {appList.map((app) => (
              <DropdownItem
                value={app.value}
                selected={selectedApp === app.value}
                key={app.value}
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '6px',
                  width: '210px',
                }}
              >
                {app.primaryText}
              </DropdownItem>
            ))}
          </Dropdown>
        </Col>
      </Row>
    </>
  )

  return (
    <>
      {(appList.length > 2 && enviroment === 'live') ||
      (appList.length > 1 && enviroment === 'sandbox')
        ? appsContent
        : null}
    </>
  )
}

export default AppSwitcher
